import React from 'react';

import { CognitoUser } from '../providers/AppStateContext';
import { useAppState } from './useAppState';

export type AdminRoleResponse = {
  isAdmin: boolean;
  isCityManager: boolean;
  isSupport: boolean;
  isSocial: boolean;
  isVenue: boolean;
  isFastCheck: boolean;
  isSuperAdmin: boolean;
  marketId: number;
  marketIds: Array<number>;
  user?: CognitoUser;
  venueId: string;
};

export const useAdminRole = (): AdminRoleResponse => {
  const [appState] = useAppState();

  const data = React.useMemo<AdminRoleResponse>(() => {
    const cognitoGroups = appState.user?.cognitoGroups || [];

    return {
      isAdmin: cognitoGroups.includes('admin'),
      isCityManager: cognitoGroups.includes('city_manager'),
      isSupport: cognitoGroups.includes('support'),
      isSocial: cognitoGroups.includes('social'),
      isVenue: cognitoGroups.includes('venue'),
      isFastCheck: cognitoGroups.includes('fastcheck'),
      isSuperAdmin: cognitoGroups.includes('superAdmin'),
      marketId: appState.selectedMarketId || 0,
      marketIds: (
        JSON.parse(appState.user?.attributes['custom:marketIds'] || '[]') as Array<string>
      ).map(Number),
      user: appState.user,
      venueId:
        (cognitoGroups.includes('venue') && appState.user?.attributes['custom:entity_id']) || null,
    };
  }, [appState.user, appState.selectedMarketId]);

  return data;
};
